import React, { useMemo } from "react";

import { EmptyState } from "@performyard/py-components";

import { ApprovalAccordion } from "./ApprovalAccordion";

import { type ManagerBudgetGroupWithCycleAllotment, budgetGroupKey } from "../../SharedComponents/utils";

type BudgetReviewsTableProps = {
	visibleBudgetGroups: ManagerBudgetGroupWithCycleAllotment[];
	compensationCycleId: string;
	cycleStatus: string;
	defaultExpanded?: boolean;
};

export const BudgetReviewsTable: React.FC<BudgetReviewsTableProps> = ({
	visibleBudgetGroups,
	compensationCycleId,
	cycleStatus,
	defaultExpanded = false,
}) => {
	const isEmpty = visibleBudgetGroups.length === 0;

	const sortedBudgetGroups = useMemo(
		() => [...visibleBudgetGroups].sort((a, b) => a.managerName.localeCompare(b.managerName)),
		[visibleBudgetGroups]
	);

	return (
		<div className="flex max-h-[596px] min-h-[596px] min-w-0 flex-1 flex-col items-stretch gap-2 overflow-x-hidden overflow-y-auto rounded-lg border border-solid border-neutral-2 bg-neutral-1 p-4">
			{isEmpty ? (
				<div className="flex min-h-0 w-full min-w-0 flex-1 flex-col justify-center [&_svg]:!h-[68px] [&_svg]:!w-[141px]">
					<EmptyState variant="illustration" option={8} label="No Budgets Found" />
				</div>
			) : (
				sortedBudgetGroups.map((budget) => (
					<ApprovalAccordion
						key={budgetGroupKey(budget)}
						budget={budget}
						compensationCycleId={compensationCycleId}
						cycleStatus={cycleStatus}
						defaultExpanded={defaultExpanded}
					/>
				))
			)}
		</div>
	);
};
